import { useQuery } from '@tanstack/react-query';
import { RQ_TENANT_GROUP_TENANTS } from 'Utils';
import { getTenantGroupTenants } from 'Services';

const useGetTenantGroupTenants = (tenantGroupId: string) => {
    return useQuery([RQ_TENANT_GROUP_TENANTS, tenantGroupId], () => getTenantGroupTenants(Number(tenantGroupId)), {
        select: (data) => {
            const tenantsWithSelectStates = data.tenants.map((tenant) => ({ ...tenant, isSelected: false })) ?? [];
            return { original: data, modifiedTenants: tenantsWithSelectStates };
        }
    });
};

export default useGetTenantGroupTenants;
